class ErrorsLegendController {
  constructor() {
    this.name = 'errorsLegend';
  }
}

export default ErrorsLegendController;



// WEBPACK FOOTER //
// ./app/common/errorsLegend/errorsLegend.controller.js